const Label = ({ text }) => {
  return (
    <div className="ant-form-item-label">
      <label>{text} :</label>
    </div>
  )
}

export default Label
